import * as constants from '../constants';
import { getLeafFieldPoints } from '../actions';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getLeafFieldPoints.success: {
            return action.payload.results || [];
        }

        case constants.getLeafFieldPoints.try:
        case constants.getLeafFieldPoints.error: {
            return initialState;
        }

        default:
            return state;
    }
}